import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TaskbarComponent } from './components/taskbar/taskbar.component';
import { NavuserComponent } from './components/navuser/navuser.component';
import { TokenInputComponent } from './components/token-input/token-input.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { AimodelSelectorComponent } from './components/aimodel-selector/aimodel-selector.component';
import { ProjectSelectorComponent } from './components/project-selector/project-selector.component';
import { NavItemOptionsComponent } from './components/nav-item-options/nav-item-options.component';
import { UploadFilesComponent } from './components/upload-files/upload-files.component';
import { ProgressModalComponent } from './components/progress-modal/progress-modal.component';
import { AlertModalComponent } from './components/alert-modal/alert-modal.component';
import { ClientSelectorComponent } from './components/client-selector/client-selector.component';
import { SharePointNavigatorComponent } from './components/sharepoint-navigator/sharepoint-navigator.component';
import { AzureWikiNavigatorComponent } from './components/azure-wiki-navigator/azure-wiki-navigator.component';
import { ConfluenceNavigatorComponent } from './components/confluence-navigator/confluence-navigator.component';
import { AgentFeedbackModalComponent } from './components/agent-feedback-modal/agent-feedback-modal.component';
import { FeedbackThanksModalComponent } from './components/feedback-thanks-modal/feedback-thanks-modal.component';
import { ChatHistorySidebarComponent } from './components/chat-history-sidebar/chat-history-sidebar.component';
import { KnowledgeCheckComponent } from './components/knowledge-check/knowledge-check.component';
import { ChangelogModalComponent } from '../changelog/modal/changelog-modal.component';
import { CapabilityDirective } from '../core/capabilities/capability.directive';

@NgModule({
  declarations: [
    NavuserComponent,
    SidebarComponent,
    TaskbarComponent,
    TokenInputComponent,
    HeaderComponent,
    AimodelSelectorComponent,
    ProjectSelectorComponent,
    NavItemOptionsComponent,
    UploadFilesComponent,
    ProgressModalComponent,
    AlertModalComponent,
    ClientSelectorComponent,
    SharePointNavigatorComponent,
    ConfluenceNavigatorComponent,
    AzureWikiNavigatorComponent,
    AgentFeedbackModalComponent,
    FeedbackThanksModalComponent,
    ChatHistorySidebarComponent,
    KnowledgeCheckComponent,
    CapabilityDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule,
    IonicModule,
    ChangelogModalComponent
  ],
  exports: [
    NavuserComponent,
    SidebarComponent,
    TaskbarComponent,
    TokenInputComponent,
    TranslateModule,
    RouterModule,
    HeaderComponent,
    AimodelSelectorComponent,
    ProjectSelectorComponent,
    NavItemOptionsComponent,
    UploadFilesComponent,
    ProgressModalComponent,
    AlertModalComponent,
    ClientSelectorComponent,
    SharePointNavigatorComponent,
    ConfluenceNavigatorComponent,
    AzureWikiNavigatorComponent,
    AgentFeedbackModalComponent,
    FeedbackThanksModalComponent,
    ChatHistorySidebarComponent,
    KnowledgeCheckComponent,
    CapabilityDirective
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
